<template>
    <div class="card">
      <div class="d-flex flex-wrap justify-content-between align-item-center mt-2 mx-2">
        <h3>Customization Manager</h3>
        <div class="gx-1">
          <button
              style="min-width: 64px;"
              @click="openCustomerAddModal"
              class="btn btn-primary waves-effect waves-float waves-light me-1"
          >Add HTML
          </button>
        </div>
      </div>
      <div class="mt-2"></div>
        <div class="px-2">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="col-form-label">Form Name/Route: </label>
                <v-select
                    placeholder="Select Form Name / Route"
                    :options="formattedCustomizationManagerForms"
                    v-model="formName"
                    :reduce="name => name.id"
                    label="name"
                />
              </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="col-form-label">Template Name: </label>
                <v-select
                    placeholder="Select Template"
                    :options="formattedPatientCardTemplate"
                    v-model="templateName"
                    :reduce="name => name.id"
                    label="name"
                />
              </div>
              <div class="col-sm-2 col-md-2 d-flex align-items-end mt-2 action-btn-setter">
                <button
                  style="min-width: 64px;"
                  @click="onClickToGo"
                  class="btn btn-primary btn-block waves-effect waves-float waves-light"
              >GO
              </button>
              </div>
            </div>
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
          <div class="card p-2" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>Type</th>
                  <th>Template Name</th>
                  <th>Form Name/ Route</th>
                  <th>Last Update</th>
                  <th>Updated By</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in tableItems" :key="i">
                  <td class="text-uppercase">{{ item.type }}</td>
                  <td>{{ formatLabel(item.template_name) }}</td>
                  <td>{{ formatLabel(item.form_name) }}</td>
                  <td>{{ item.formated_update_at }}</td>
                  <td>{{ item.update_user }}</td>
                  <td>{{ formatLabel(item.status) }}</td>
                  <td>
                    <button class="btn btn-primary btn-sm"
                            @click="openCustomerEditModal(item)"
                            style="cursor: pointer"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
            </div>
          </div>
        </div>

        <div class="px-2 position-absolute bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

        <Loader v-if="loading"/>

      <AddHtmlCustomizationModal
          v-if="store.state.isModalOpenTwo"
          :isEdit="isEdit"
          :formData="formData"
          @onCreateCustomizationManager="onCreateCustomizationManager"
      />

    </div>
</template>

<script setup>
import AddHtmlCustomizationModal from '@/views/page/company/customization-manager/AddHtmlCustomizationModal'
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import handleCompany from "@/services/modules/company";
import handleChartAccount from '@/services/modules/chartAccount'

import { computed } from 'vue';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const isEdit = ref(false)
const formName = ref(null)
const templateName = ref(null)
const tableItems = ref([]);
const params = ref({
    offset: 10,
});
const editData = ref({})

const token = computed(() => localStorage.getItem('token'));
const customizationManagerForms = ref({});
const patientCardTemplate = ref({});
const { fetchCustomizationManagerList, fetchSingleCustomizationManager } = handleCompany();
const {fetchHome} = handleChartAccount()

const formattedCustomizationManagerForms = computed(() => {
  return Object.keys(customizationManagerForms.value).map(key => ({ id: key, name: customizationManagerForms.value[key] }));
})

const formattedPatientCardTemplate = computed(() => {
  return Object.keys(patientCardTemplate.value).map(key => ({ id: key, name: patientCardTemplate.value[key] }));
})
const onClickToGo = () => {
  getCustomizationManager();
}

const formatLabel = (value) => {
  if (!value) return '';
  return value.replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
}

const onCreateCustomizationManager = () => {
  getCustomizationManager();
}

const formData = ref({
  type: 'html',
  template_name: null,
  form_name: null,
  status: 'active',
})

const openCustomerAddModal = () => {
  isEdit.value = false
  formData.value = {
    type: 'html',
    template_name: null,
    form_name: null,
    status: 'active',
  };
  store.state.isModalOpenTwo = true
}

function setFormData() {
  formData.value.id = editData.value.id
  formData.value.type = editData.value.type;
  formData.value.template_name = editData.value.template_name;
  formData.value.form_name = editData.value.form_name;
  formData.value.status = editData.value.status;
}

const openCustomerEditModal = (item) => {
  isEdit.value = true
  const fetchSingleData = fetchSingleCustomizationManager(item.id, getQuery());
  fetchSingleData.then(res => {
    if (res.status){
      store.state.isModalOpenTwo = true;
      editData.value = res.data;
      setFormData();
    }
  });
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    await getCustomizationManager();
}

const getCustomizationManager = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []

    await fetchCustomizationManagerList(query).then(res => {
        if (!res.status){
            store.commit("resetPagination")
            return
        }
        tableItems.value = res.data.data;
        setPagination(res.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (formName.value) query += '&form_name=' + formName.value;
    if (templateName.value) query += '&template_name=' + templateName.value;
    query += '&offset=' + params.value.offset
    return query;
}

onMounted(() => {
  Promise.all([
    getCustomizationManager(),
    fetchHome().then(res => {
      if (!res.data) {
        return;
      }
      if (res.data.customization_manager_form) {
        customizationManagerForms.value = res.data.customization_manager_form
      }
      if (res.data.patient_card_template) {
        patientCardTemplate.value = res.data.patient_card_template
      }
    })
  ])

})
</script>
